import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/aboutUs";
import ContactPage from "./pages/contactPage";
import OurServices from "./pages/ourservices";
import TempPage from "./pages/404";
// import Connect from "./pages/Connect";
// import LandingPage from "./pages/landingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
// import ReadingGuide from "./pages/ReadingGuide"; // static — replaced by Type 2 Blogs via /posts/:slug
import GuideStylePost from "./pages/GuideStylePost";
// import DeleteUser from "./pages/DeleteAccount";
// import UserPage from "./pages/UserPage";
// import AccountingBookkeepingServices from "./pages/AccountingBookkeepingServices";
import MoreDetails from "./components/partials/MoreDetails"
//These imports declare each page as variable to be rendered using react router

//Declares routes and the elements rendered
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          
          <Route path="/privacypolicy" element={<PrivacyPolicy />}></Route>
          {/* <Route path="/deleteuser" element={<DeleteUser />}></Route> */}
          {/* <Route path="/connect" element={<Connect />}></Route> */}
          {/* <Route path="/moreServices" element={<AccountingBookkeepingServices />}></Route> */}
          <Route path="/moredetails" element={<MoreDetails />}></Route>
          {/* Route to Home Page */}
          <Route path="/" element={<Home />}></Route>
          {/* Route to about us page */}
          <Route path="/aboutus" element={<AboutUs />}></Route>
          {/* Route to Our services page */}
          <Route path="/ourservices" element={<OurServices />}></Route>
          <Route
            path="/blogs"
            element={<Navigate to="/?allPosts=1" replace />}
          ></Route>
          {/* Static reading guide — replaced by Type 2 Blog at /posts/:slug */}
          {/* <Route path="/reading-guide" element={<ReadingGuide />}></Route> */}
          <Route path="/posts/:slug" element={<GuideStylePost />}></Route>
          {/* Route to contact page */}
          <Route path="/contactpage" element={<ContactPage />}></Route>
          {/* If a unknown URL is accessed, Redirect to /404 */}
          {/* <Route path="/comingsoon" exact element={<LandingPage />}></Route> */}
          {/* <Route path="/myaccount" exact element={<UserPage />}></Route> */}
     
          {/* /404 page. FourOFour component is rendered with a link to return Home */}
          <Route path="/404" exact element={<TempPage />}></Route>
          
          <Route path="*" exact element={<Navigate to="/404" />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
//Exports App component
export default App;
